<section class="support">
  <div class="support__container">
    <div class="support__intro">
      <p class="support__eyebrow">{{ "ASP Marketplace" | translate }}</p>
      <h2 class="support__title">{{ "Need help?" | translate }}</h2>
      <p class="support__text">
        {{
          "Find a verified consulting company for business registration, licensing and ongoing support — all key services in one convenient ASP Marketplace."
            | translate
        }}
      </p>
    </div>

    <div class="support__grid">
      <button
        *ngFor="let card of cards"
        type="button"
        class="support-card"
        (click)="openMarketplace(card)"
      >
        <span class="support-card__body">
          <span class="support-card__title">{{ card.titleKey | translate }}</span>
          <span class="support-card__text">{{ card.descriptionKey | translate }}</span>
        </span>
        <span nz-icon nzType="arrow-right" class="support-card__arrow"></span>
      </button>
    </div>
  </div>
</section>
